import styled from "styled-components";

export default styled.p`
    margin-bottom: 12px;
    font-style: italic;
    text-transform: uppercase;
    margin-bottom: 12px;
`
